import React, { Component } from 'react';
import AdSense from 'react-adsense';
import './Ad.css';

const clientId = 'ca-pub-7709048971046465';

class Ad extends Component {

	render() {

		let banner = '';
		let localClass = '';

		if(location.hostname !== "localhost") {
			if(this.props.type==='leaderboard') {
				banner = <AdSense.Google
					client={clientId}
					slot='8144888020'
					style={{ display: 'block' }}
					format='auto'
				/>;
			}
			if(this.props.type==='medium-rectangle') {
				banner = <AdSense.Google
					client={clientId}
					slot='5674513649'
					style={{ display: 'inline-block', width: '300', height: '250', float: 'left' }}
					format=''
				/>;
			}
		} else {
			banner = this.props.type;
			localClass = ' local';
		}

		return (
			<div className={'Ad ' + this.props.type + localClass}>
				{banner}
			</div>
		);
	}
}

export default Ad;



// WEBPACK FOOTER //
// ./src/components/Ad.js